(() => {
  if (window.__saKlaviyoAtcLoaded) return;
  window.__saKlaviyoAtcLoaded = true;

  const ADD_SOURCES = new Set([
    'product-form',
    'quick-add',
    'cart-upsell',
    'sa-dashcam-quiz',
    'cart-package-protection',
  ]);
  const recentEvents = new Map();

  const toMoney = (value) => {
    const amount = Number(value || 0);
    return Number.isFinite(amount) ? amount / 100 : 0;
  };

  const absoluteUrl = (url) => {
    if (!url) return window.location.href;

    try {
      return new URL(url, window.location.origin).href;
    } catch (error) {
      return window.location.href;
    }
  };

  const getVariantId = (item) => item?.variant_id || item?.id;

  const getCart = async () => {
    try {
      const response = await fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js', {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return null;
      return response.json();
    } catch (error) {
      return null;
    }
  };

  const getItemFromEvent = (event) => {
    const cartData = event?.cartData;
    if (!cartData || Array.isArray(cartData.items)) return null;
    if (!getVariantId(cartData)) return null;

    return cartData;
  };

  const shouldTrack = (event, item) => {
    if (!ADD_SOURCES.has(event?.source)) return false;

    const variantId = getVariantId(item);
    const eventKey = `${event.source}:${variantId}:${item.quantity || 1}:${item.key || ''}`;
    const now = Date.now();

    for (const [key, timestamp] of recentEvents) {
      if (now - timestamp > 3000) recentEvents.delete(key);
    }

    if (recentEvents.has(eventKey)) return false;
    recentEvents.set(eventKey, now);

    return true;
  };

  const buildPayload = (item, cart) => {
    const productName = item.product_title || item.title || item.name || '';
    const variantId = String(getVariantId(item) || '');
    const productId = String(item.product_id || '');
    const quantity = Number(item.quantity || 1);
    const price = toMoney(item.final_price || item.price);
    const linePrice = toMoney(item.final_line_price || item.line_price || (item.price || 0) * quantity);
    const productUrl = absoluteUrl(item.url);
    const imageUrl = absoluteUrl(item.image || item.featured_image?.url);
    const cartItems = cart?.items || [item];
    const itemNames = cartItems.map((cartItem) => cartItem.product_title || cartItem.title).filter(Boolean);
    const items = cartItems.map((cartItem) => ({
      ProductID: String(cartItem.product_id || ''),
      VariantID: String(getVariantId(cartItem) || ''),
      SKU: cartItem.sku || '',
      ProductName: cartItem.product_title || cartItem.title || '',
      VariantName: cartItem.variant_title || '',
      Quantity: Number(cartItem.quantity || 1),
      ItemPrice: toMoney(cartItem.final_price || cartItem.price),
      RowTotal: toMoney(cartItem.final_line_price || cartItem.line_price),
      ProductURL: absoluteUrl(cartItem.url),
      ImageURL: absoluteUrl(cartItem.image || cartItem.featured_image?.url),
      ProductType: cartItem.product_type || '',
      Brand: cartItem.vendor || '',
    }));

    return {
      $value: cart ? toMoney(cart.total_price) : linePrice,
      AddedItemProductName: productName,
      AddedItemProductID: productId,
      AddedItemSKU: item.sku || '',
      AddedItemCategories: item.product_type ? [item.product_type] : [],
      AddedItemImageURL: imageUrl,
      AddedItemURL: productUrl,
      AddedItemPrice: price,
      AddedItemQuantity: quantity,
      ProductName: productName,
      ProductID: productId,
      SKU: item.sku || '',
      Categories: item.product_type ? [item.product_type] : [],
      ImageURL: imageUrl,
      URL: productUrl,
      Brand: item.vendor || '',
      Price: price,
      CompareAtPrice: toMoney(item.compare_at_price),
      VariantID: variantId,
      VariantName: item.variant_title || '',
      ItemNames: itemNames,
      Items: items,
    };
  };

  const trackKlaviyo = (payload) => {
    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Added to Cart', payload);
      return;
    }

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', payload]);
  };

  const handleCartUpdate = async (event) => {
    const item = getItemFromEvent(event);
    if (!item || !shouldTrack(event, item)) return;

    const cart = await getCart();
    trackKlaviyo(buildPayload(item, cart));
  };

  const init = () => {
    if (typeof subscribe !== 'function') return false;
    if (typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return false;

    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    return true;
  };

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
